import { GET_ALL_PLAYER, GET_USER_TRIP_DETAIL } from "./actions";

const initialState = {
  playerList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  userTripList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  loading: true,
};

const playerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_PLAYER:
      return {
        ...state,
        playerList: payload,
        loading: false,
      };
    case GET_USER_TRIP_DETAIL:
      return {
        ...state,
        userTripList: payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default playerReducer;
